import { Typography, styled } from '@mui/material';

const LabelText = styled(Typography)`
  font-size: 1rem;
  font-weight: 400;
  color: ${({ color }) => color || 'black'};
  margin: 2px;
`;

export default LabelText;
